import * as ng from 'angular';
import uiRouter from '@uirouter/angularjs';
import {ConservazioneCaricaDocumentoRegistroRiepilogativoIvaStep2Component} from './conservazione-carica-documento-registro-riepilogativo-iva-step2';

// @ngInject
const stateConfig = ($stateProvider: ng.ui.IStateProvider) => {
  $stateProvider
    .state('home.conservazione-carica-documento-registro-riepilogativo-iva-step2', {
      url: '/conservazione-carica-documento-registro-riepilogativo-iva-step2',
      ncyBreadcrumb: {
        label: 'Carica Registro Riepilogativo IVA',
        parent: 'home.conservazione'
      },
      data: {
        authorisationLevel: 1,
        pageTitle: 'Conservazione Carica Documento'
      },
      views: {
        homeContent: {
          template: '<conservazione-carica-documento-registro-riepilogativo-iva-step2 flex="100"></conservazione-carica-documento-registro-riepilogativo-iva-step2>'
        }
      }
    });
}

stateConfig.$inject = ['$stateProvider'];

export const ConservazioneCaricaDocumentoRegistroRiepilogativoIvaStep2Module: string = ng
  .module('conservazione-carica-documento-registro-riepilogativo-iva-step2', [
    'ui.bootstrap',
    uiRouter
  ])
  .component('conservazioneCaricaDocumentoRegistroRiepilogativoIvaStep2', ConservazioneCaricaDocumentoRegistroRiepilogativoIvaStep2Component)
  .config(stateConfig)
  .name;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/home/conservazione/conservazione-carica-documento-registro-riepilogativo-iva-step2/conservazione-carica-documento-registro-riepilogativo-iva-step2.module.ts